// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dtJA","label":"styles_label__1vHvP"};